const faqs = [
  {
    q: '91黑料网的内容来源是什么？',
    a: '91黑料网的内容来自多渠道信息整合，包括社交媒体公开信息、网友投稿爆料、业内消息人士提供线索以及团队自主追踪的热点事件。所有内容均经过编辑团队的多源交叉核实后才发布。',
  },
  {
    q: '如何向91黑料投稿爆料？',
    a: '您可以通过本站"投稿爆料"页面提供的邮箱或官方社交账号联系我们。爆料一经采用将给予稿酬，我们严格保护爆料人的隐私信息，绝不透露任何可识别身份的信息。',
  },
  {
    q: '91黑料APP在哪里下载？',
    a: '您可以在本站"APP下载"区域找到官方下载入口。目前支持安卓和iOS双平台，安装后可享受更流畅的浏览体验和实时推送通知功能。',
  },
  {
    q: '网站内容多久更新一次？',
    a: '91黑料秉持"不打烊"理念，编辑团队7×24小时轮班追踪热点，确保重要爆料事件发生后第一时间更新。平均每日更新量超过200条内容。',
  },
  {
    q: '如何判断爆料的真实性？',
    a: '我们设有专业的内容审核团队，每条爆料在发布前都会经过信息源交叉验证、证据链完整性评估等流程。带有"独家爆料"标签的内容均经过更严格的审核标准。',
  },
  {
    q: '被爆料方可以申请删除内容吗？',
    a: '如涉及的内容存在事实性错误，被爆料方可通过官方渠道提交证明材料申请更正。但我们不会因任何商业压力或私下协商而删除经过核实的真实爆料内容。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          常见问答<i className="ri-question-line text-primary-500 ml-2"></i>
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">你想知道的都在这里</p>

        <div className="mt-8 max-w-3xl mx-auto flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{faq.q}</h3>
                <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-background-200 group-open:bg-primary-100 transition-colors">
                  <i className="ri-arrow-down-s-line text-sm text-foreground-600 group-open:text-primary-500 group-open:rotate-180 transition-transform"></i>
                </div>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}